import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

interface LanguageToggleProps {
  className?: string
}

export function LanguageToggle({ className }: LanguageToggleProps) {
  const { i18n } = useTranslation()

  const activeLanguage = i18n.resolvedLanguage ?? i18n.language
  const isMn = activeLanguage.startsWith('mn')
  const isEn = activeLanguage.startsWith('en')

  return (
    <div
      className={cn(
        'inline-flex h-8 items-center rounded-lg bg-secondary p-0.5 ring-1 ring-border',
        className,
      )}
    >
      <button
        type="button"
        onClick={() => i18n.changeLanguage('mn')}
        className={cn(
          'h-7 w-10 rounded-md text-xs font-medium tracking-wide transition-all duration-150 whitespace-nowrap',
          isMn
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        MN
      </button>
      <button
        type="button"
        onClick={() => i18n.changeLanguage('en')}
        className={cn(
          'h-7 w-10 rounded-md text-xs font-medium tracking-wide transition-all duration-150 whitespace-nowrap',
          isEn
            ? 'bg-card text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground',
        )}
      >
        EN
      </button>
    </div>
  )
}
